/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAssociateUsersRequest
 */
export interface ControlAssociateUsersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAssociateUsersRequest
     */
    emails: Array<string>;
}

/**
 * Check if a given object implements the ControlAssociateUsersRequest interface.
 */
export function instanceOfControlAssociateUsersRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "emails" in value;

    return isInstance;
}

export function ControlAssociateUsersRequestFromJSON(json: any): ControlAssociateUsersRequest {
    return ControlAssociateUsersRequestFromJSONTyped(json, false);
}

export function ControlAssociateUsersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAssociateUsersRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emails': json['emails'],
    };
}

export function ControlAssociateUsersRequestToJSON(value?: ControlAssociateUsersRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emails': value.emails,
    };
}

